import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, map, Observable, Subscription, switchMap, tap } from 'rxjs';

import { Schema } from '../../../shared/models/schema.model';
import { SchemaRepository } from '../../../shared/repositories/schema.repository';
import { PatientSchemaTableComponent } from '../../../shared/components/schema-tables/patient-schema-table/patient-schema-table.component';
import { calculatePaginationPages } from '../../../shared/helpers/pagination-helper';
import { SessionStoreRepository } from '../../../shared/repositories/session.repository';
import { LoadingSpinnerBorderComponent } from "../../../shared/components/loading/loading-spinner-border/loading-spinner-border.component";
import { SchemaTabs } from '../../../shared/enums/schema-status';

@Component({
    selector: 'patient-others-schema-list',
    templateUrl: './others-schema-list.component.html',
    styleUrl: './others-schema-list.component.scss',
    imports: [CommonModule, PatientSchemaTableComponent, LoadingSpinnerBorderComponent]
})
export class OthersSchemaListComponent implements OnInit, OnDestroy {
	private readonly schemaRepository = inject(SchemaRepository);
	private readonly sessionService = inject(SessionStoreRepository);

	private subscription = new Subscription();

	readonly SchemaTab = SchemaTabs.OTHERS;

	schemas$ = this.schemaRepository.patientOtherSchemas$;
	isPatient$ = this.sessionService.isPatient$;
	isLoading$ = new BehaviorSubject<boolean>(true).asObservable();

	paginatedSchemas$ = new Observable<Schema[]>;
    tabKey: string = "others";

	currentPage: number = 1;
	perPage: number = 10;
	lastPage: number = 1;
	pages: number = 1;
	total: number = 0;
	pagesIntervalSize: number = 5;
	visiblePaginationPages: number[] = [];

	ngOnInit() {
		this.subscription.add(
			this.schemaRepository.getPatientOtherSchemas$().pipe(
				switchMap(() => this.schemaRepository.patientOtherSchemas$),
				tap(schemas => {
					this.total = schemas.length;
					this.lastPage = Math.ceil(this.total / this.perPage);
					this.pages = Math.ceil(this.total / this.perPage);
				}),
				map(schemas => {
					const data = schemas;
					const paginatedData = data.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
					return new BehaviorSubject({ paginatedData }).asObservable();
				})
			).subscribe(result => {
				this.paginatedSchemas$ = result.pipe(map(x => x.paginatedData));
				this.isLoading$ = this.schemaRepository.patientOtherSchemasIsLoading$;
				this.visiblePaginationPages = calculatePaginationPages(this.currentPage, this.lastPage, this.pages, this.pagesIntervalSize);
			})
		);
	}

	ngOnDestroy(): void {
		if (this.subscription) this.subscription.unsubscribe();
	}

}
